import { VueConstructor } from 'vue'
import { toThousand } from '@/utils'

export default {
  install(Vue: VueConstructor) {
    Vue.filter('toThousand', toThousand)
  }
}
